// extracted by mini-css-extract-plugin
export default {"menu":"MenuBar_menu__l-NlB","active":"MenuBar_active__lsstC"};